/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ConversationSpeechMetricsOut } from './conversationSpeechMetricsOut';
import type { ConversationTimingMetricsOut } from './conversationTimingMetricsOut';
import type { ParticipantMetricsOut } from './participantMetricsOut';

export interface ConversationMetricsOut {
  computed_at: string;
  timing: ConversationTimingMetricsOut;
  speech: ConversationSpeechMetricsOut;
  participants: ParticipantMetricsOut[];
}
